import React from 'react';

// #332: the Auto Run Mode toggle that lived here was a UI stub for a
// per-user auto-fire scheduler that never shipped to production.
// The scheduler module itself is gone; every cycle is user-triggered
// via mobile "Run now" or the desktop tray. Settings keeps only the
// genuinely status-bearing rows below.
export function Settings(): React.ReactElement {
  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold text-text-primary">Settings</h1>

      <div className="bg-white border border-border rounded-lg divide-y divide-border">
        <div className="px-6 py-4 flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-text-primary">MFA Status</p>
            <p className="text-xs text-text-muted mt-0.5">
              Multi-factor authentication is required for all admin accounts.
            </p>
          </div>
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Enabled
          </span>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm font-medium text-text-primary">Version</p>
          <p className="text-xs text-text-muted mt-0.5">
            OutLinked Admin Portal v0.1.0 · Plan 5
          </p>
        </div>
      </div>
    </div>
  );
}
